<template>
  <div class="mb-1">
    <div class="row">
      <div class="col-12" v-if="!mapInstitutionsLoading">
        <multiple-select-input 
        id="institionSelect"
        :model.sync="selectedInstitution"
        :values="institutionsBranchesList"
        :model="model"
        :multiple="false"
      />
      </div>
      <div class="col-12" v-else>
        <div class="row" >
          <div class="col-12">
            <loading-box></loading-box>
          </div>
        </div>
      </div>
    </div>
    
   
    </multiple-select-input>
    <div class="map-section" v-if="!mapInstitutionsBranchLoading">
      <gmap-map
        ref="mainMap"
        :center="startLocation"
        :zoom="6"
        map-type-id="roadmap"
        style="width: 100%; height: 100%"
        :options="{
          zoomControl: true,
          scaleControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          streetViewControl: false,
          disableDefaultUi: false,
        }"
      >
        <gmap-marker
          v-for="(item, key) in coordinates"
          :key="key"
          :position="getPosition(item)"
          :clickable="true"
          :icon="icon"
          @click="toggleInfo(item, key)"
        ></gmap-marker>
        <gmap-circle
          :editable="editable"
          :draggable="draggable"
          :radius="radius"
          :center="circleCenter"
          :options="options"
          :color="yellow"
        >
        </gmap-circle>
      </gmap-map>
      <transition name="map-info-window-slide">
        <div
          class="map-info-window"
          :opened="infoOpened"
          :position="infoPosition"
          v-if="infoOpened"
        >
          <div class="city-info" v-if="selectedMarker">
            <div class="city-location">{{ selectedMarker.full_name }}</div>
            <div class="city-name">{{ selectedMarker.address }}</div>
            <div class="map-btn-close-holder">
              <button
                class="btn btn-danger map-btn-close"
                @click="closeInfoWindow()"
              >
                {{ $t("dashboard.close") }}
              </button>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="card-body" v-else>
<loading-box></loading-box>
    </div>
  </div>
</template>
 
<script>
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput.vue";
import LoadingBox from "@/assets/components/loader/LoadingBox.vue";
import baseModule, {
  ERROR,
  MODULE_NAME,
  MAP_INSTITUTIONS,
  GET_MAP_INSTITUTIONS,
  MAP_INSTITUTIONS_BRANCH,
  GET_MAP_INSTITUTIONS_BRANCH,
  SUCCESS,
  GET_MAP_INSTITUTIONS_LOADING,
  GET_MAP_INSTITUTIONS_BRANCH_LOADING,
} from "@/core/services/store/dashboard.module";
import store from "@/core/services/store";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "DashboardInstitutionBranchesMaps",
  components: {
    MultipleSelectInput,
    LoadingBox,
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(_MODULE_NAME, baseModule);
  },
  data: function () {
    return {
      selectedInstitution: null,
      startLocation: {
        lat: 39.5708783,
        lng: 35.6807645,
      },
      editable: true,
      draggable: true,
      population: 8405837,
      circleCenter: { lat: 40.714, lng: -74.005 },
      icon: null,
      iconList: [
        {
          url: "http://masima.limonist.ist/public/assets/images/black.png",
          size: { width: 40, height: 40, f: "px", b: "px" },
          scaledSize: { width: 40, height: 40, f: "px", b: "px" },
        },
        {
          url: "http://masima.limonist.ist/public/assets/images/danger.png",
          size: { width: 40, height: 40, f: "px", b: "px" },
          scaledSize: { width: 40, height: 40, f: "px", b: "px" },
        },
        {
          url: "http://masima.limonist.ist/public/assets/images/marker.png",
          size: { width: 40, height: 40, f: "px", b: "px" },
          scaledSize: { width: 40, height: 40, f: "px", b: "px" },
        },
        {
          url: "http://masima.limonist.ist/public/assets/images/success.png",
          size: { width: 40, height: 40, f: "px", b: "px" },
          scaledSize: { width: 40, height: 40, f: "px", b: "px" },
        },
        {
          url: "http://masima.limonist.ist/public/assets/images/warning.png",
          size: { width: 40, height: 40, f: "px", b: "px" },
          scaledSize: { width: 40, height: 40, f: "px", b: "px" },
        },
      ],
      options: {
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#FF0000",
        fillOpacity: 0.35,
      },
      coordinates: [],
      selectedKey: null,
      selectedMarker: null,
      infoOpened: false,
    };
  },
  computed: {
    model(){
      if(this.institutionsBranchesList.length<=1)return this.institutionsBranchesList[0].id
      return null
    },
    error() {
      return store.getters[_MODULE_NAME + "/" + ERROR];
    },
    mapInstitutionsLoading() {
      return store.getters[_MODULE_NAME + "/" + GET_MAP_INSTITUTIONS_LOADING];
    },
    mapInstitutionsBranchLoading() {
      return store.getters[
        _MODULE_NAME + "/" + GET_MAP_INSTITUTIONS_BRANCH_LOADING
      ];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
    institutions() {
      return store.getters[_MODULE_NAME + "/" + MAP_INSTITUTIONS];
    },
    institutionsBranches() {
      return store.getters[_MODULE_NAME + "/" + MAP_INSTITUTIONS_BRANCH];
    },
    institutionsBranchesList() {
      let institutionsBranches = this.institutions;
      if (!institutionsBranches) return 0;
      return institutionsBranches;
    },
  },
  methods: {
    getMarkers(key) {
      if (this.selectedKey === key) return this.mapMarkerActive;
      return this.mapMarker;
    },
    getPosition: function (marker) {
      return {
        lat: parseFloat(marker.lat),
        lng: parseFloat(marker.lng),
      };
    },
    toggleInfo: function (marker, key) {
      this.infoPosition = this.getPosition(marker);
      this.selectedMarker = marker;
      this.selectedKey = key;
      this.infoOpened = !this.infoOpened;
    },
    closeInfoWindow: function () {
      this.infoOpened = false;
      this.markerOptions = this.mapMarker;
    },
    async filterResults() {
      this.$store.dispatch(_MODULE_NAME + "/" + GET_MAP_INSTITUTIONS, {});
      await this.$store.dispatch(
        _MODULE_NAME + "/" + GET_MAP_INSTITUTIONS_BRANCH,
        {
          filters: {
            id: this.selectedInstitution,
          },
        }
      );
      let coordinates = this.institutionsBranches;
      if (coordinates.length < 1) this.coordinates = [];
      this.institutionsBranches.forEach((item) => {
        this.coordinates.push({
          full_name: item.name,
          lat: item.latitude,
          lng: item.longitude,
          address: item.address,
        });
      });
      let randomIcon = this.iconList[_.random(1, 4)];
      this.icon = randomIcon;
    },
  },
  mounted() {
    let randomIcon = this.iconList[_.random(1, 4)];
    this.icon = randomIcon;
    this.filterResults();
  },
  watch: {
    async selectedInstitution() {
      await this.$store.dispatch(
        _MODULE_NAME + "/" + GET_MAP_INSTITUTIONS_BRANCH,
        {
          filters: {
            id: this.selectedInstitution,
          },
        }
      );
      this.coordinates=[]
      let coordinates = this.institutionsBranches;
      if (coordinates.length < 1) this.coordinates = [];
      this.institutionsBranches.forEach((item) => {
        this.coordinates.push({
          full_name: item.name,
          lat: item.latitude,
          lng: item.longitude,
          address: item.address,
        });
      });
      let randomIcon = this.iconList[_.random(1, 4)];
      this.icon = randomIcon;
    },
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#institionSelect {
  position: absolute;
  z-index: 99;
  top: 4px;
  width: 350px;
  right: 20px;
}
.map-section {
  height: 500px;
  position: relative;
  overflow: hidden;
}

.map-info-window {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  background: #fff;
}

.map-info-window-slide-leave-active,
.map-info-window-slide-enter-active {
  transition: 0.5s;
}

.map-info-window-slide-enter {
  transform: translate(0, -100%);
}

.map-info-window-slide-leave-to {
  transform: translate(0, -100%);
}

.city-info > div {
  margin-bottom: 10px;
}

.map-btn-close-holder {
  margin-top: 10px;
}
</style>
  